import React from 'react'
import type { Icon } from 'shared/utils'
export const CircleBacon = (props: Icon) => {
    const {
        color = 'black',
        background = '#A11A2C',
        size = 32,
        className = 'circle-bacon',
        ...otherProps
    } = props
    const transform = `translate(${(size - 24) / 2} ${(size - 24) / 2})`
    return (
        <svg
            width={size}
            height={size}
            fill={color}
            className={className}
            {...otherProps}>
            <g fillRule="nonzero">
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={size / 2}
                    fill={background}
                />
                <path
                    transform={transform}
                    d="M17.98 2.833c-1.406.96-2.316 2.368-2.778 3.96a12 12 0 00-.41 2.23c-.091.959-.17 1.93-.564 2.826-.286.65-.75 1.152-1.428 1.433-.713.298-1.494.356-2.254.47-2.848.426-5.021 2.91-5.213 5.617L8.771 22s-.309-3.174 3.243-3.633c4.063-.523 7.61-3.318 7.61-6.005 0-5.214 2.26-7.739 2.337-7.887.448-.852-3.1-1.493-3.982-1.64v-.002z"
                />
                <path
                    transform={transform}
                    d="M5.695 15.46c1-1.336 2.52-2.404 4.16-2.686.703-.12 1.465-.145 2.13-.432.778-.337 1.034-1.154 1.188-1.945.176-.903.186-1.831.328-2.74.123-.79.315-1.57.604-2.311.462-1.19 1.152-2.229 2.062-3.069C14.654 2.054 12.553 2 12.553 2c-.83.016-1.492 1.55-1.576 2.771-.083 1.221.318 3.09-.527 4.194-1.364 1.784-2.546.171-5.202 2.193C3.036 12.845 2 16.386 2 16.386l2.308 2.28a7.439 7.439 0 011.387-3.206z"
                />
            </g>
        </svg>
    )
}
